'use strict';

angular.module('searchModule', ['riskModule']);